import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface ToastOptions {
  type: ToastType
  message: string
  duration?: number
}

const toasts = ref<Array<ToastOptions & { id: number }>>([])
let nextId = 1

export function useToast() {
  const showToast = (options: ToastOptions) => {
    const id = nextId++
    const toast = { ...options, id }
    toasts.value.push(toast)

    // 自动关闭
    setTimeout(() => {
      const index = toasts.value.findIndex((t) => t.id === id)
      if (index !== -1) {
        toasts.value.splice(index, 1)
      }
    }, options.duration || 3000)
  }

  return {
    toasts,
    showToast,
  }
}
